import { features } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="bg-background-50">
      <div className="mx-auto max-w-none px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-primary-600">
              <i className="ri-apps-2-line" />
              Highlights
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">功能亮点</h2>
            <p className="mt-2 text-sm text-foreground-600">
              不只是能下载，91免费版在下载体验、流量控制与数据同步上都做了针对性优化。
            </p>
          </div>
          <span className="hidden self-start text-xs text-foreground-500 md:block">图文并重 · 4 项核心能力</span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:gap-5">
          {features.map((feat) => (
            <article
              key={feat.title}
              className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="h-40 w-full overflow-hidden md:h-44">
                <img
                  src={feat.image}
                  alt={feat.title}
                  title={`91免费版${feat.title}`}
                  className="h-full w-full object-top"
                />
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-lg text-accent-700">
                    <i className={feat.icon} />
                  </span>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{feat.title}</h3>
                </div>
                <p className="mt-3 text-xs leading-relaxed text-foreground-600">{feat.summary}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}